import { elementToForgeDoc } from '../../../utils/elementToForgeDoc';
import React from 'react';
import PlatformTextfield from '@atlaskit/textfield';
import { adaptEventHandler } from '../../utils';
import { useCursorState } from '../../utils/useCursorState';
export var Textfield = function Textfield(props) {
  var _ref = props.forgeDoc.props,
    appearance = _ref.appearance,
    elemAfterInput = _ref.elemAfterInput,
    elemBeforeInput = _ref.elemBeforeInput,
    isCompact = _ref.isCompact,
    autoFocus = _ref.autoFocus,
    isReadOnly = _ref.isReadOnly,
    isMonospaced = _ref.isMonospaced,
    placeholder = _ref.placeholder,
    testId = _ref.testId,
    width = _ref.width,
    type = _ref.type,
    defaultValue = _ref.defaultValue,
    min = _ref.min,
    max = _ref.max,
    maxLength = _ref.maxLength,
    minLength = _ref.minLength,
    pattern = _ref.pattern,
    id = _ref.id,
    isRequired = _ref.isRequired,
    isDisabled = _ref.isDisabled,
    isInvalid = _ref.isInvalid,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    value = _ref.value,
    ariaInvalid = _ref['aria-invalid'],
    ariaLabelledby = _ref['aria-labelledby'],
    name = _ref.name;
  var _useCursorState = useCursorState(value, onChange),
    onChangeWithCursorState = _useCursorState.onChangeWithCursorState,
    inputRef = _useCursorState.inputRef;
  return /*#__PURE__*/React.createElement(PlatformTextfield, {
    ref: inputRef,
    appearance: appearance
    // forge/react reconciler does not convert components in props into ForgeDoc. We need to do it manually here
    ,
    elemAfterInput: elemAfterInput ? props.render(elementToForgeDoc(elemAfterInput)) : null
    // forge/react reconciler does not convert components in props into ForgeDoc. We need to do it manually here
    ,
    elemBeforeInput: elemBeforeInput ? props.render(elementToForgeDoc(elemBeforeInput)) : null,
    isCompact: isCompact,
    autoFocus: autoFocus,
    isReadOnly: isReadOnly,
    isMonospaced: isMonospaced,
    placeholder: placeholder,
    testId: testId,
    width: width,
    type: type,
    defaultValue: defaultValue,
    min: min,
    max: max,
    maxLength: maxLength,
    minLength: minLength,
    pattern: pattern
    // Field props
    ,
    id: id,
    isRequired: isRequired,
    isDisabled: isDisabled,
    isInvalid: isInvalid,
    onChange: adaptEventHandler(onChangeWithCursorState),
    onBlur: adaptEventHandler(onBlur),
    onFocus: adaptEventHandler(onFocus),
    value: value,
    "aria-invalid": ariaInvalid,
    "aria-labelledby": ariaLabelledby,
    name: name
  });
};